<template>
  <v-data-table
    :headers="headers"
    :items="prescriptions"
    :loading="loading"
    :options.sync="options"
    :server-items-length="totalCount"
  >
    <template #[`item.statusId`]="{item}">
      <v-chip outlined small :color="getStatusColor(item.statusId)">{{item.statusId}}</v-chip>
    </template>
    <template #[`item.clientId`]="{item}">
      {{ item.client.displayName }}
    </template>
    <template #[`item.shopId`]="{item}">
      {{ item.shop.name }}
    </template>
    <template #[`item.clubFitterId`]="{item}">
      {{ item.clubFitter ? item.clubFitter.displayName : '-' }}
    </template>
    <template #[`item.fittingTypeId`]="{item}">
      {{ item.fittingType ? item.fittingType.name : item.fittingTypeId }}
    </template>
    <template #[`item.fittingDate`]="{item}">
      {{ item.fittingDate | formatDate }}
    </template>
    <template #[`item.updated_at`]="{item}">
      {{ item.updated_at | formatDate(true) }}
    </template>
    <template #[`item.action`]="{item}">
      <v-btn v-if="item.statusId == 'new'" small outlined color="error" class="mr-2" @click="deleteItem(item.id)">
        delete
      </v-btn>
      <v-btn small outlined @click="open(item.id)">
        view
      </v-btn>
      <ConfirmBox ref="confirm" />
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment';
import _ from "lodash";
import { mapActions, mapGetters } from 'vuex';
import hasQueryParams from '../../mixins/hasQueryParams.vue';
import ConfirmBox from "../ui/ConfirmBox.vue";

export default {
  name: 'PrecriptionList',
  mixins: [hasQueryParams],
  components: {ConfirmBox},
  props: {
    headers: {
      type: Array
    },
    filters: {
      type: Object
    },
    tabs: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      search: "",
      options: { itemsPerPage: 15 },
      formOpen: false,
      searchFilters: this.filters,
      items:[],
      queryFields: ['page', 'itemsPerPage', 'prescriptionSortBy', 'sortDesc'],
      totalCount:0,
      prescriptions:[]
    };
  },
  watch: {
    options: {
      handler: _.debounce(function() {
        this.fetchPrescriptions();
      }, 100),
      deep: true
    },
    search: {
      handler: _.debounce(function() {
        this.fetchPrescriptions();
      }, 100)
    },
    filters: {
      handler: _.debounce(function() {
        this.fetchPrescriptions();
      }, 100),
      deep: true
    },
    tabs: {
      handler: _.debounce(function() {
        this.fetchPrescriptions();
      }, 100)
    }
  },
  computed: {
    ...mapGetters("prescriptions", ["loading"]),
    query () {
      return {
        page: this.options.page.toString(),
        itemsPerPage: this.options.itemsPerPage.toString(),
        prescriptionSortBy: this.options.sortBy.toString(),
        sortDesc: this.options.sortDesc.toString()
      }
    }
  },
  filters:{
      formatDate (value, hour) {
          if (!value) return '';
          return hour ? moment(value).format('DD/MM/YYYY, HH:mm:ss') : moment(value).format('DD/MM/YYYY');
      }
  },
  mounted: function() {
    this.parseQuery()
    this.fetchPrescriptions();
  },
  methods: {
    ...mapActions("prescriptions", {getPrescriptions: 'index', deletePrescription: 'delete'}),
    parseQuery(){
      this.options = {
        ...this.options,
        page: this.$route.query.page ? parseInt(this.$route.query.page): 1,
        itemsPerPage: this.$route.query.itemsPerPage ? parseInt(this.$route.query.itemsPerPage): 15,
        sortBy: this.getSortFromQuery(),
        sortDesc: [this.$route.query.sortDesc === 'false' ? false : true]
      }
    },
    getSortFromQuery() {
      const sort = this.$route.query.prescriptionSortBy
      if(sort && this.headers.find(h => h.value == sort)){
        return [sort]
      }
      return ["fittingDate"]
    },
    getStatusColor(status){
      switch (status) {
        case 'quoted':
          return 'orange'
        case 'shipped':
          return 'green'
        case 'readyToBuild':
        case 'built':
          return 'blue'
        default:
          break;
      }
    },
    fetchPrescriptions() {
      this.pushNewRoute()
      this.getPrescriptions({
        pagination: this.options,
        search: this.search,
        filters: this.filters
      }).then(({prescriptions}) => {
        this.prescriptions = prescriptions.data
        this.totalCount = prescriptions.total
      }) 
    },
    open(id) {
      this.$router.push("/prescription/view/" + id);
    },
    async deleteItem(id) {
      if(await this.$refs.confirm.open("Are you sure ?", "Do you really want delete this subscription ?")){
        this.deletePrescription({
            id: id
          })
          .then(() => {
            this.flashMessage.success({
              message: 'Prescription deleted',
            });
          })
          .finally(() => {
            this.fetchPrescriptions();
          });
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
